import DataTable from '../../../../../components/DataTable/DataTable';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import { FormattedDate, FormattedMessage, FormattedNumber, FormattedTime, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { getClosedTransactions } from '../../../../../store/actions/dashboard/closedTransactions';
import { LOADING } from '../../../../../enums/states';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import socketContext from '../../../../../context/SocketContext';
import MoneyIcon from '@material-ui/icons/Money';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import { Tooltip } from '@material-ui/core';

const closedTransactionsTableColumns = [
  {
    id: 'postedOn',
    label: <FormattedMessage id={'postedTransaction.closedOn'}/>,
    align: 'left',
  },
  {
    id: 'documentNo',
    label: <FormattedMessage id={'transaction.documentNo'}/>,
    align: 'left',
  },
  {
    id: 'createdBy',
    label: <FormattedMessage id={'transaction.createdBy'}/>,
    align: 'left',
  },
  {
    id: 'note',
    label: <FormattedMessage id={'transaction.note'}/>,
    align: 'left',
  },
  {
    id: 'itemCount',
    label: <FormattedMessage id={'transaction.itemCount'}/>,
    align: 'right',
  },
  {
    id: 'amount',
    label: <FormattedMessage id={'transaction.total'}/>,
    align: 'right',
  },
  {
    id: 'payments',
    label: <FormattedMessage id={'transaction.payments'}/>,
    align: 'center',
  },
  {
    id: 'action',
    label: '',
    align: 'right',
  },
];

const Payments = ({payments}) => {
  const intl = useIntl();
  const types = {
    'CARD': <Tooltip title={intl.formatMessage({ id: 'payment.card' })}><CreditCardIcon /></Tooltip>,
    'CASH': <Tooltip title={intl.formatMessage({ id: 'payment.cash' })}><MoneyIcon /></Tooltip>,
  }
  return <>
    {payments && payments?.map((payment, index) => {
      return <span key={index}>{types[payment.name] || payment.name}</span>
    })}
  </>
}

const ClosedTransactions = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const closedTransactionsRedux = useSelector((state) => state?.dashboard?.closedTransactions);


  const [closedTransaction, setClosedTransaction] = useState();
  const [closedTransactionCount, setClosedTransactionCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  let { path } = useRouteMatch();

  useEffect(() => {
    if (closedTransactionsRedux?.data?.transactions) {
      setClosedTransaction(
        closedTransactionsRedux.data.transactions.map((line) => {
          return {
            ID: line.ID,
            postedOn: (
              <>
                <FormattedDate value={line.modified_on}/> <FormattedTime value={line.modified_on}/>
              </>
            ),
            documentNo: line.document_no,
            createdBy: line.name,
            amount: <FormattedNumber value={line.totalAmount} minimumFractionDigits={2}/>,
            itemCount: <FormattedNumber value={line.lineCount}/>,
            note: line.note,
            payments: <Payments payments={line.payments} />,
            action: <><ArrowForwardIcon/></>
          };
        }),
      );
      setClosedTransactionCount(closedTransactionsRedux.data.count);
    }
  }, [closedTransactionsRedux, closedTransactionsRedux?.data]);

  useEffect(() => {
    dispatch(getClosedTransactions(page, rowsPerPage));
  }, [dispatch, page, rowsPerPage]);

  const refreshClosedTransactions = useCallback(() => {
    dispatch(getClosedTransactions(page, rowsPerPage));
  }, [dispatch, page, rowsPerPage]);

  const socket = useContext(socketContext);

  useEffect(() => {
    socket.on('TRANSACTION_POSTED', refreshClosedTransactions);

    return () => {
      socket.off('TRANSACTION_POSTED', refreshClosedTransactions);
    };
  });


  return <DataTable
    loading={closedTransactionsRedux?.state === LOADING}
    columns={closedTransactionsTableColumns}
    data={closedTransaction}
    onRowClick={(row) => {
      history.push(`${path}/transaction/${row.ID}`);
    }}
    pagination
    page={page}
    count={closedTransactionCount}
    rowsPerPage={rowsPerPage}
    onChangePage={(event, page) => {setPage(page)}}
    onChangeRowsPerPage={(e) => {setPage(0); setRowsPerPage(e.target.value)}}
  />
}

export default ClosedTransactions;
